<template>
  <div v-if="adCampaign">
    <div
      v-for="cleverreach of adCampaign.cleverreachReports"
      :key="cleverreach.id"
      class="bi-campaign--info-box"
    >
      <h3>{{ cleverreach.name }}</h3>
      <table class="important-informations mb-8">
        <thead>
          <tr>
            <th>Versender Name</th>
            <th>Versender Mail</th>
            <th>Versand</th>
            <th>Empfänger</th>
            <th>Versand Rate</th>
            <th>Öffnungs Rate</th>
            <th>Nicht Öffnungs Rate</th>
            <th>Abgemeldet</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ cleverreach.senderName }}</td>
            <td>{{ cleverreach.senderEmail }}</td>
            <td>{{ formatDate(cleverreach.date) }}</td>
            <td>{{ cleverreach.totalReceiverCount }}</td>
            <td>
              {{ cleverreach.stats.basic.deliveredRate.toLocaleString() }} %
              <br />
              <span>{{
                cleverreach.stats.basic.delivered.toLocaleString()
              }}</span>
            </td>
            <td>
              {{ cleverreach.stats.basic.openedRate.toLocaleString() }} %<br />
              <span>{{
                cleverreach.stats.basic.totalOpened.toLocaleString()
              }}</span>
            </td>
            <td>
              {{ cleverreach.stats.basic.notOpenedRate.toLocaleString() }}
              %<br />
              <span>{{
                cleverreach.stats.basic.notOpened.toLocaleString()
              }}</span>
            </td>
            <td>
              {{ cleverreach.stats.basic.unsubscribeRate.toLocaleString() }}
              %<br />
              <span>{{
                cleverreach.stats.basic.unsubscribed.toLocaleString()
              }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <CleverreachReportLinks :links="cleverreach.stats.links" />
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import CleverreachReportLinks from "./stats/CleverreachReportLinks.vue";

export default {
  components: {
    CleverreachReportLinks
  },
  props: {
    campaignId: { type: String, required: true }
  },
  apollo: {
    adCampaign: {
      query: gql`
        query adCampaign($id: ID!) {
          adCampaign(id: $id) {
            id
            cleverreachReports {
              id
              name
              subject
              senderName
              senderEmail
              date
              totalReceiverCount
              stats {
                id
                basic {
                  id
                  delivered
                  deliveredRate
                  totalOpened
                  openedRate
                  notOpened
                  notOpenedRate
                  bounced
                  bouncedRate
                  unsubscribed
                  unsubscribeRate
                }
                links {
                  id
                  name
                  link
                  uniqueClicks
                  totalClicks
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.campaignId
        };
      }
    }
  },
  methods: {
    formatDate(unix) {
      return moment.unix(unix).format("DD.MM.YY");
    }
  }
};
</script>
